import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _cloneDeep from "lodash/cloneDeep";
import _merge from "lodash/merge";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import fetchAPI from 'utils/http/fetchAPI';
import endUserMessages from 'utils/endUserMessages';
import { LOAD_CONFIG } from 'redux/actionTypes/componentConfig';
import { initialPlotConfigStates } from 'redux/reducers/componentConfig/initialState';
import handleError from 'utils/http/handleError';
import httpStatusCodes from 'utils/http/httpStatusCodes';
var loadPlotConfig = function loadPlotConfig(experimentId, plotUuid, plotType) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _data, _plotConfig;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchAPI("/v2/experiments/".concat(experimentId, "/plots/").concat(plotUuid));
            case 3:
              _data = _context.sent;
              _plotConfig = _merge({}, initialPlotConfigStates[plotType], _data.config);
              dispatch({
                type: LOAD_CONFIG,
                payload: {
                  experimentId: experimentId,
                  plotUuid: plotUuid,
                  plotType: plotType,
                  plotData: _data.plotData,
                  config: _plotConfig
                }
              });
              _context.next = 14;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              if (!(_context.t0.statusCode === httpStatusCodes.NOT_FOUND)) {
                _context.next = 13;
                break;
              }
              dispatch({
                type: LOAD_CONFIG,
                payload: {
                  experimentId: experimentId,
                  plotUuid: plotUuid,
                  plotType: plotType,
                  plotData: [],
                  config: _cloneDeep(initialPlotConfigStates[plotType])
                }
              });
              return _context.abrupt("return");
            case 13:
              handleError(_context.t0, endUserMessages.ERROR_FETCHING_PLOT_CONFIG);
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default loadPlotConfig;